import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/tablet-fixes.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Disable React Dev Overlay for production-like experience
// This prevents "Script error" overlays from appearing
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_DISABLE_ERROR_OVERLAY === 'true') {
  // Suppress cross-origin "Script error" from appearing in overlay
  window.addEventListener('error', (event) => {
    // Check if it's a cross-origin script error
    if (event.message === 'Script error.' || event.message === 'Script error') {
      event.preventDefault();
      console.warn('[Error Handler] Cross-origin script error suppressed');
      return true;
    }
  });

  // Also handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.warn('[Error Handler] Unhandled promise rejection:', event.reason);
    // Prevent overlay for cross-origin errors
    if (event.reason?.message === 'Script error.' || event.reason?.message === 'Script error') {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
